import React, { useState, useEffect, useRef } from 'react';
import copy from 'copy-to-clipboard'
import { buildShareText } from '../share-text'
import ShareSheet from './ShareSheet'
import { getSiteConfig } from '../constantFunction'
import { pickOrphanEgg } from '../orphan-egg'

import { format } from 'date-fns'

import '../index.css'
// import 'github-markdown-css'
import Loading from '../components/Loading'

// import "highlight.js/styles/github.css";
// import 'highlight.js/styles/dark.css';
// import 'highlight.js/styles/hopscotch.css'; 
// import hljs from "highlight.js";

import { Button, Tooltip } from 'antd';


// 文章正文
// 分享按钮图标：纸飞机线稿，跟随文字色（原 antd ShareAltOutlined 三点连线在 14px 下像个「<」）
function SendIcon() {
    return (
        <span className="anticon" role="img" aria-hidden="true">
            <svg className="send-icon" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 3 3.5 10.2l6.8 2.9L13 20z" />
                <path d="M10.3 13.1 21 3" />
            </svg>
        </span>
    )
}

function Container(props) {

    // 记录文章的 DOM 信息，用来处理 DOM 元素，例如修改图片样式
    let post = useRef(null);
    // Tooltips 显示、隐藏
    let [TooltipsOpen, setTooltipsOpen] = useState(false)
    // 分享面板（二维码）是否打开：管理员在设置中心开了 site.shareQr 才用它
    let [shareOpen, setShareOpen] = useState(false)
    // 记录当前文章的 ID
    let [thisPageId, setPageID] = useState('')

    // 记录自定义的 Link 数据，用来实现 DOM 链接的间接跳转
    // let [my_link, setLink] = useState('');

    // 如果当前页面 ID 为空则获取数据
    if (thisPageId === '' && props.card && props.card.card) {
        setPageID(props.card.card.id)
    }

    // 点击反向链接
    const handleBackLinkClick = (link_id, current_id) => {
        console.log('handleBackLinkClick');
        console.log(link_id);
        // 记录跳转类型
        sessionStorage.setItem('nav_type', 0)
        // 记录当前滚动的位置
        sessionStorage.setItem('scrollY', window.scrollY)

        props.handleLinkClick(link_id, current_id)

    }

    // 点击文内链接
    const handleAarticleLinkClick = (node) => {

        if (node !== undefined) {

            if (node.classList.contains('article_link') !== true || node.getAttribute('path') === undefined || node.getAttribute('path') === null) {
                // 如果 DOM 中的元素**不**包含 path 属性，则跳过（有 path 属性的元素才需要处理）

            } else {
                let post_id = node.getAttribute('path').replace('/post/', '')
                let parent_note_id = node.getAttribute('parent_note_id')

                if (node.getAttribute('addClickHandleFlag') !== '1') {
                    // 如果未绑定事件，则绑定，否则不绑定
                    node.setAttribute('addClickHandleFlag', '1')

                    node.addEventListener('click', function () {
                        // 记录跳转类型
                        sessionStorage.setItem('nav_type', 1)
                        // 记录当前滚动的位置
                        sessionStorage.setItem('scrollY', window.scrollY)
                        props.handleLinkClick(post_id, parent_note_id)
                    })
                }


                // node.removeEventListener('click', handleAarticleLinkClickInstant.bind(Event, post_id, parent_note_id))
                // node.addEventListener('click', handleAarticleLinkClickInstant.bind(Event, post_id, parent_note_id))

                // node.removeEventListener('click', ttest,false)
                // node.addEventListener('click', ttest,false)

                // node.onClick = handleAarticleLinkClickInstant.bind(Event,post_id, parent_note_id)
                // node.onClick = function () {
                //     console.log('ok');
                //     handleAarticleLinkClickInstant(Event, post_id, parent_note_id)
                // }


            }

        }

    }

    // 分享：站点开了「分享按钮弹二维码面板」就弹面板（微信扫码打开后再转发才出卡片）；
    // 否则复制「《标题》/ 作者 / 链接 / 来源」署名块（格式见 share-text.js）
    const handleCopyBtnClick = () => {
        const site = getSiteConfig()
        if (site && site.shareQr) {
            setShareOpen(true)
            return
        }
        copy(buildShareText(props['card']['card']))
        // 显示 Tooltips
        setTooltipsOpen(true)

        setTimeout(() => {
            // 隐藏 Tooltips
            setTooltipsOpen(false)
        }, 1400);
    }

    // Tooltips 显示、隐藏状态变化时
    const handleTooltipOnOpenChange = () => {
        console.log('onOpenChange');
    }

    // 组件生命周期，组件载入、更新时将触发此函数
    useEffect(() => {

        console.log('useEffect====================');
        if (props.card && props.card.card) {
            props.handleHashChange(window.location.href, props['card']['card']['id'])
        }

        // dom 加载完毕后
        if (post.current != null) {

            // 设置网易云音乐播放器的尺寸

            // 设置 img 的尺寸
            // let article_img = document.getElementsByTagName('img');

            // for (let i = 0; i < article_img.length; i++) {
            //     let width_key_index = article_img[i]['alt'].indexOf('{{width ')
            //     if (width_key_index > -1) {
            //         let img_width = article_img[i]['alt'].substring(width_key_index, article_img[i]['alt'].length)
            //         img_width = img_width.replace('{{width ', '')
            //         img_width = img_width.replace('}}', '')

            //         article_img[i].setAttribute('style', 'width:' + (Number(img_width.replace('%', '')) * mobileSkale).toString() + '%')
            //         article_img[i].style.display = 'block'
            //         article_img[i].style.margin = '0 auto'
            //     }
            // }

            // 设置 a 链接的点击事件，将 a 按照 Link 的方式进行跳转，避免页面不必要的刷新
            let article_link = document.getElementsByClassName('article_link');

            for (let i = 0; i < article_link.length; i++) {

                if (article_link[i].classList.contains('article_link') !== true || article_link[i].getAttribute('path') === undefined || article_link[i].getAttribute('path') === null) {
                    // 如果 DOM 中的元素**不**包含 path 属性，则跳过（有 path 属性的元素才需要处理）
                    continue
                }

                setTimeout(() => {

                    handleAarticleLinkClick(article_link[i])

                }, 10);

            }

            // 滚动到对应卡片的位置
            setTimeout(() => {
                // document.getElementsByClassName('notes')[0].scrollTo({ left: last_note[last_note.length - 1].offsetLeft, behavior: 'smooth' })
            }, 100);


        }

        // // 代码高亮
        // // if (document.querySelectorAll('pre').length > 0) {
        // //     document.querySelectorAll('pre').forEach(element => {
        // //         hljs.highlightBlock(element);
        // //     });
        // // }




    });

    // 加载中
    if (false) {
        console.log('isLoading');

        return <Loading />


    } else {

        // 反向链接（About 页不传 card，这里要兜底成空数组）
        const cardId = props['card'] && props['card']['card'] ? props['card']['card']['id'] : ''
        const backLinkList = props['card'] && props['card']['backLinks'] ? props['card']['backLinks'] : []
        let backLinksBody
        if (backLinkList.length > 0) {
            backLinksBody = <ul>
                {backLinkList.map((backLink) =>
                    <li key={backLink.id} >
                        <span className='my_link' onClick={handleBackLinkClick.bind(this, backLink.id, cardId)}>
                            {backLink.title}
                        </span>
                    </li>
                )}
            </ul>
        } else {
            // 空态彩蛋：按卡片 id 固定 + 节日/深夜覆盖，见 orphan-egg.js
            const egg = pickOrphanEgg(cardId)
            backLinksBody = <div className='backLinks-empty' title={egg.text}>
                <span className='backLinks-empty-emoji' aria-hidden='true'>{egg.emoji}</span>
                <span className='backLinks-empty-text'>{egg.text}</span>
            </div>
        }
        const backLinksBox = <div className='markdown-body backLinks'>
            <header>🔗LINKS TO THIS PAGE</header>
            {backLinksBody}
        </div>



        // note_id / data-note-title 供划线复制（copy-attribution.js）从选区反查是哪张卡
        return <div style={props['style']} ref={post} className='markdown-body container' note_id={cardId} data-note-title={props['card'] && props['card']['card'] ? props['card']['card']['title'] || '' : ''}>

            <article className='note_article' dangerouslySetInnerHTML={{ 
                __html: props['card'] && props['card']['card'] && props['card']['card']['content'] instanceof HTMLElement 
                    ? props['card']['card']['content'].innerHTML 
                    : '' 
            }}></article>
            <div className='article_bottom'>
                <div style={{ flex: 1 }}>
                    {props['card'] && props['card']['card'] && props['card']['card']['createdTime'] && (
                        <time>Created {format(new Date(props['card']['card']['createdTime']), 'yyyy-MM-dd')}</time>
                    )}
                    {props['card'] && props['card']['card'] && props['card']['card']['lastEditedTimeDiff'] && (
                        <time>{props['card']['card']['lastEditedTimeDiff']}</time>
                    )}
                </div>
                {props['card'] && props['card']['card'] && props['card']['card']['id'] && (
                    <Tooltip placement="left" color='green' title='Copied' trigger='click' arrowPointAtCenter={false} onOpenChange={handleTooltipOnOpenChange} open={TooltipsOpen}>
                        <Button onClick={handleCopyBtnClick} size="small" className="copy-btn" aria-label="分享" icon={<SendIcon />} />
                    </Tooltip>
                )}
            </div>
            <ShareSheet card={props['card'] && props['card']['card']} open={shareOpen} onClose={() => setShareOpen(false)} />
            {backLinksBox}

        </div>
    }

}

export default Container;